export const countUserQuestions = (questionList) => questionList.filter(
  (question) => question.internal_name?.includes('@'),
).length;
